import { FETCH_REPORT_TESTING_SHEET_REQUEST, FETCH_REPORT_TESTING_SHEET_SUCCESS, FETCH_REPORT_TESTING_SHEET_FAILURE } from './actions';

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const reportTestingSheetReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_REPORT_TESTING_SHEET_REQUEST:
            return { ...state, loading: true };
        case FETCH_REPORT_TESTING_SHEET_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case FETCH_REPORT_TESTING_SHEET_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default reportTestingSheetReducer;
